export default __webpack_public_path__ + "static/media/ISEO_CLASS-7_SYLLABUS_2025-26.ab96165f.pdf";